export default __webpack_public_path__ + "static/media/metrics.ac7c30a9.svg";